/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PasswordResetData
 */
export interface PasswordResetData {
  /**
   *
   * @type {string}
   * @memberof PasswordResetData
   */
  newPassword: string;
  /**
   *
   * @type {string}
   * @memberof PasswordResetData
   */
  token: string;
}
